import { Component, Host, h } from '@stencil/core';
/**
 * @slot  - Slot for adding dialog content.
 */
export class DialogContent {
  render() {
    return (h(Host, null,
      h("slot", null)));
  }
  static get is() { return "sy-dialog-content"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
}
